import { useState, useEffect } from "react";
import InAppMessage, { InAppMessagePresentation } from "../../models/InAppMessage";
import InAppMessagesService from "../../services/crud/InAppMessageService";
import { Button, Checkbox, DatePicker, Dropdown, Form, FormInstance, Input, Select, Spin, TimePicker, Tooltip } from "antd";
import { LoadingOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { EntitySelector } from "./selects/EntitySelector";
import moment from "moment";
import { LangKeyList } from "../../models/LangKey";
import { LocalizedField } from "./inputs/LocalizedField";

export const InAppMessageFormGenericForm = (props) => {
  const form: FormInstance = props.form;
  const id = props.id;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.resetFields();
    if (id) {
      setLoading(true);
      InAppMessagesService.getInAppMessage(id).then((data) => {
        setLoading(false);

        data.sentAt = data.sentAt ? (moment(data.sentAt) as any) : null;
        data.viewedAt = data.viewedAt ? (moment(data.viewedAt) as any) : null;
        data.dismissedAt = data.dismissedAt ? (moment(data.dismissedAt) as any) : null;
        data.expiresAt = data.expiresAt ? (moment(data.expiresAt) as any) : null;
        data.title = data.title ? JSON.parse(data.title) : null;
        data.shortBody = data.title ? JSON.parse(data.shortBody) : null;
        data.longBody = data.title ? JSON.parse(data.longBody) : null;

        form.setFieldsValue(data);
      });
    }

    // Load data
  }, [form, id]);

  const selectAccountByEmail = () => {

  };

  if (loading) {
    return <></>;
  }

  const content = (
    <Form<InAppMessage> form={form}>
      <Form.Item noStyle name="id">
        <Input type="hidden" />
      </Form.Item>

      <Form.Item label="To" name="toAccountId" required>
        <EntitySelector.Accounts accountTypes={['private']} style={{width: '50%'}}/>
        <Button style={{width: '50%'}} onClick={selectAccountByEmail}>Find private account by email</Button>
      </Form.Item>
      <Tooltip title="Recipient of the in-app-message">
        <QuestionCircleFilled />
      </Tooltip>

      <LocalizedField
        supportedLanguages={LangKeyList}
        name="title"
        inputType="input"
        label="Title"
        placeholder=" "
        minLabelWidth={20}
        required
      />
      <Tooltip title="Title of the in-app-message">
        <QuestionCircleFilled />
      </Tooltip>

      <LocalizedField
        supportedLanguages={LangKeyList}
        name="shortBody"
        inputType="input"
        label="Short body"
        placeholder=" "
        minLabelWidth={20}
      />
      <Tooltip title="Short body of the in-app-message">
        <QuestionCircleFilled />
      </Tooltip>

      <LocalizedField
        supportedLanguages={LangKeyList}
        name="longBody"
        inputType="input"
        label="Long body"
        placeholder=" "
        minLabelWidth={20}
        required
      />
      <Tooltip title="Long body of the in-app-message">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Show popup" name="showPopup">
        <Checkbox defaultChecked />
      </Form.Item>

      <Form.Item label="Presentation" name="presentation" required>
        <Select
          options={[{value: InAppMessagePresentation.HomeTab}]}
          defaultValue={InAppMessagePresentation.HomeTab}
        />
      </Form.Item>

      { form.getFieldValue("id") && (
        <>
          <Form.Item label="Sent at" name="sentAt">
            <DatePicker format="YYYY-MM-DD" style={{ width: "50%" }} />
            <TimePicker format="HH:MM:SS" style={{ width: "50%" }} />
          </Form.Item>
          <Tooltip title="Date+time when the message was sent">
            <QuestionCircleFilled />
          </Tooltip>
        </>
      )}

      <Form.Item label="Viewed at" name="viewedAt">
        <DatePicker format="YYYY-MM-DD" style={{ width: "50%" }} />
        <TimePicker format="HH:MM:SS" style={{ width: "50%" }} />
      </Form.Item>
      <Tooltip title="If set, the in-app-message was first viewed in the app at this time (and will not show up as popup again)">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Dismissed at" name="dismissedAt">
        <DatePicker format="YYYY-MM-DD HH:MM:SS" style={{ width: "50%" }} />
        <TimePicker format="YYYY-MM-DD HH:MM:SS" style={{ width: "50%" }} />
      </Form.Item>
      <Tooltip title="If set, the in-app-message will not be shown in app any more">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Expires at" name="expiresAt">
        <DatePicker format="YYYY-MM-DD HH:MM:SS" style={{ width: "50%" }} />
        <TimePicker format="YYYY-MM-DD HH:MM:SS" style={{ width: "50%" }} />
      </Form.Item>
      <Tooltip title="If set, the in-app-message will automatically be hidden after this time">
        <QuestionCircleFilled />
      </Tooltip>
    </Form>
  );

  if (loading) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />}>
        {content}
      </Spin>
    );
  }
  return content;
};

